import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useTable } from "react-table";
import { generateOwnersTableData } from "./columns";
import { sanitizeInput } from "../../../../utils/utils";
import "./checklisttable.scss";
import { useSalesChecklistComment } from "../../../../hooks/useSalesChecklistComment";

const OwnersTable = ({ salesOwnerProperty, userId, salesAdditionalNote }) => {
  const notesLookup = useMemo(() => {
    if (!Array.isArray(salesAdditionalNote)) return {};
    return salesAdditionalNote.reduce((acc, item) => {
      if (item.section && typeof item.note === "string") {
        acc[item.section] = item.note;
      }
      return acc;
    }, {});
  }, [salesAdditionalNote]);

  const { data, columns } = useMemo(
    () => generateOwnersTableData(salesOwnerProperty),
    [salesOwnerProperty]
  );

  const { commentData, setCommentData, originalNotesRef, updateSalesData } =
    useSalesChecklistComment({
      userId,
      sanitizeFn: sanitizeInput
    });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  return (
    <table
      className="table-fixed mt-2 mb-3 businesstable ownerstable ownerColumn redColumn borderless_table bgless_table"
      {...getTableProps()}
    >
      <thead>
        {headerGroups.map((headerGroup, index) => (
          <tr
            {...headerGroup.getHeaderGroupProps()}
            key={headerGroup.id || index}
          >
            {headerGroup.headers.map((column, index) => (
              <th
                {...column.getHeaderProps()}
                key={column.id || index}
                className="only-td-style"
              >
                {column.render("Header")}
              </th>
            ))}
          </tr>
        ))}
      </thead>

      <tbody {...getTableBodyProps()}>
        {rows.map((row, index) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} key={row.id || index}>
              {row.cells.map((cell, cellIndex) => (
                <td
                  {...cell.getCellProps()}
                  key={cell.column.id || cellIndex}
                  className={`border-0 p-0 m-0 ${cellIndex === row.cells.length - 2 ? "second-last-td" : ""}`}
                >
                  {cell.column.id === "fundtap_notes"
                    ? cell.render("Cell", {
                        updateSalesData,
                        commentData,
                        setCommentData,
                        originalNotesRef,
                        rowId: row.id,
                        sectionEnum: row.original.sectionEnum,
                        noteValue: notesLookup[row.original.sectionEnum] ?? ""
                      })
                    : cell.render("Cell")}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

OwnersTable.propTypes = {
  salesOwnerProperty: PropTypes.array,
  userId: PropTypes.string,
  salesAdditionalNote: PropTypes.array
};

export default OwnersTable;
